import { render } from "./plan.vue?vue&type=template&id=25afc0fa"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__